import LangEnum from '../../../../lang/LangEnum';
import { ErrorResponse, TeceoApiResponse } from '../../../../lib/basicRepository';
import { HTTP_STATUS } from '../../../../utils/httpStatus.const';
import { GridItemSkuDTO } from '../../../products/details/productDetails.types';
import { ProductActionsResponseData } from '../../../products/repositories/types/productActions.types';
import { createApiSauceResponse } from '../../utils/createApiSauceResponse.util';

export const createCustomerUnauthorizedProductError =
  (): TeceoApiResponse<ProductActionsResponseData> => {
    return createApiSauceResponse<ProductActionsResponseData, ErrorResponse>({
      ok: false,
      data: {
        code: LangEnum.API_EXCEPTION_CUSTOMER_UNAUTHORIZED_PRODUCT,
        message: 'o cliente não tem acesso ao produto',
        status: HTTP_STATUS.UNPROCESSABLE_ENTITY,
      },
    });
  };

export const createCustomerUnauthorizedKitError = (): TeceoApiResponse<GridItemSkuDTO[]> => {
  return createApiSauceResponse<GridItemSkuDTO[], ErrorResponse>({
    ok: false,
    data: {
      code: LangEnum.API_EXCEPTION_CUSTOMER_UNAUTHORIZED_PRODUCT,
      message: 'o cliente não tem acesso ao produto',
      status: HTTP_STATUS.UNPROCESSABLE_ENTITY,
    },
  });
};
